import {
  getPerformanceBenchmarkReport,
  GetPerformanceBenchmarkReportRequestParams,
} from "@/requests/reports/performance-benchmark-report.request";
import { useQuery } from "@tanstack/react-query";

export const usePerformanceBenchmarkReport = (
  params: GetPerformanceBenchmarkReportRequestParams,
  enabled = true,
) => {
  return useQuery({
    queryKey: [
      "companies",
      params.companyId,
      "reports",
      "questionnaires",
      "performance-benchmark",
      {
        editionId: params.editionId,
        group: params.group,
      },
    ],
    queryFn: () => getPerformanceBenchmarkReport(params),
    enabled: !!params.companyId && enabled,
  });
};
